export const socialsPoland = {
  linkedin: "https://www.linkedin.com/company/anixe-polska-sp--z-o-o-/",
  facebook: "https://www.facebook.com/ANIXEpl/",
  instagram: "https://www.instagram.com/anixecompany/",
  twitter: "https://twitter.com/anixepl",
};
